import { Moises } from '../../../../lib/cli'
import { config } from '../../../../config'

const MoisesCLI = Moises({ apiEndpoint: config.api.endpoint })

export async function saveSectionsMutation({
  sections,
  trackId,
  userToken,
  restore = false
}: {
  sections: any
  trackId: string
  userToken: any
  restore?: boolean
}): Promise<any> {
  MoisesCLI.auth(userToken)
  const result = await MoisesCLI.updateTrackMetadata({
    trackId,
    key: 'sections',
    value: JSON.stringify(restore ? [] : sections)
  })
  return result
}
